// extracted by mini-css-extract-plugin
export default {"rotate90":"iconStyles_rotate90__QShBT"};